module.exports = "<div class=\"page-header-fixed\">\n    <div class=\"header navbar navbar-inverse navbar-fixed-top\" ui-view=\"header\" data-role=\"navigation\"></div>\n    <div class=\"dashboard-container\">\n        <div ui-view></div>\n    </div>\n    <!-- <div class='footer'>\n        <div class='footer-inner'>\n            <section copyright id=\"support-button\"></section> | <a ng-href=\"/changelog\" style=\"color:#999999\"> Change Log </a>\n        </div>\n    </div> -->\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing/views/index.html
 ** module id = 444
 ** module chunks = 0
 **/